import { FormattedMessage, useIntl } from 'react-intl';

import { AutoDismissFlag } from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import { ComponentFlagId, HandleDismissedType } from 'src/redux/flags/types';
import { settings } from 'src/settings';

import { messages } from './create-workspace-error-flag.i18n';

type Props = {
  id: ComponentFlagId;
  description: string;
} & HandleDismissedType;

const CreateWorkspaceErrorFlag = ({
  id,
  description,
  ...otherProps
}: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <AutoDismissFlag
      {...otherProps}
      id={id}
      title={intl.formatMessage(messages.workspaceCreateErrorTitle)}
      icon={
        <StatusErrorIcon
          spacing="spacious"
          label="Error"
          color={token('color.icon.danger')}
        />
      }
      description={
        <FormattedMessage
          {...messages.workspaceCreateErrorDescription}
          values={{
            link: chunks => <a href={settings().STATUSPAGE_URL}>{chunks}</a>,
          }}
        />
      }
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default CreateWorkspaceErrorFlag;
